// extracted by mini-css-extract-plugin
export default {"xs":"426","sm":"769","md":"1110","lg":"1201","xl":"1441","containerSize":"1350","backgroundMain":"#00a0ff","backgroundSecond":"#1596c0"};